<template>
  <AbaFiltro v-if="!loading" :titulo="titulo">
    <ValidationProvider
      rules="required"
      v-slot="{ errors }"
      mode="eager"
      name="unimed"
    >
      <unicom-autocomplete
        :mensagemErro="errors[0]"
        style="padding-bottom: 32px"
        mostrarIconeExcluir
        colorPlaceholder="#9E9E9E"
        placeholder="Unimed"
        v-model="objetoFiltro.unimed.descricao"
        @index="
          index => selecionarChave(index, 'unimed', listaUnimeds, 'codigo')
        "
        :items="listaUnimeds.map(e => e.textoExibicao)"
      />
    </ValidationProvider>
    <unicom-campo-calendario-v3
      fecharClique
      regrasValidacao="required|validacaoMes"
      :duploClique="false"
      v-model="objetoFiltro.competencia"
      placeHolder="Competência"
      mostrarIconeExcluir
      :componentesAtivos="['Meses', 'Anos']"
    />
    <template slot="botao">
      <unicom-botao
        :desabilitado="!habilitado"
        @click="proximaAba"
        :largura="360"
        :altura="40"
      >
        CONTINUAR
      </unicom-botao>
    </template>
  </AbaFiltro>
  <unicom-spinner
    v-else
    style="
      min-height: 450px;
      display: flex;
      flex-flow: wrap column;
      justify-content: center;
    "
    :tamanhoLoading="62"
    :tamanhoLinha="7"
    :velocidade="0.5"
    :marginTopTexto="30"
    mensagem="Carregando..."
  />
</template>

<script>
import AbasMixin from "../AbasMixin";
import AbaFiltroMixin from "../AbaFiltroMixin";
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationProvider
  },
  mixins: [AbasMixin, AbaFiltroMixin],
  data() {
    return {
      listaUnimeds: []
    };
  },
  beforeMount() {
    this.inicializarUnimeds();
  },
  methods: {
    inicializarUnimeds() {
      this.loading = true;
      this.sleep(500).finally(() => {
        this.getAllUnimeds()
          .then(res => {
            this.listaUnimeds = res.data;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>

<style></style>
